<template>
    <div class="manage-content">
        <div class="location">企业管理中心 / 使用指南</div>
        <div class="white-bg shadow margin-top-20 padding30 radius">
            <div class="use-box">
                <h3>一、企业认证注册</h3>
                <p>企业用户选择企业角色进行认证申请，需如实填写企业相关信息。填写并提交资料后，{{this.$store.state.siteName}}相关工作人员将会在3个工作日内和企业预约拜访、核实资料，待企业资料核实无误后即可通过企业认证，成为{{this.$store.state.siteName}}的企业用户。</p>
                <h3>二、关于企业会员</h3>
                <p>1、企业在“开通会员”页面点击立即开通，通过微信支付充值365元会员年费，即可成为{{this.$store.state.siteName}}企业会员。</p>
                <p>2、{{this.$store.state.siteName}}企业会员可专享发布任务功能，以及使用{{this.$store.state.siteName}}全部功能。</p>
                <h3>三、关于悬赏金</h3>
                <p>1、什么是悬赏金</p>
                <p class="sj">悬赏金即企业发布任务时需支付给达人的预算费用，待达人完成任务时，平台会将其支付给达人，作为达人完成任务的赏金。</p>
                <p>2、怎么充值悬赏金</p>
                <p class="sj">(1) 企业可通过微信支付充值悬赏金。</p>
                <p class="sj">(2) 推荐企业/达人进驻亦可获得相应的悬赏金福利。</p>
                <p class="img"><img src="@/assets/images/qiyezhinan.png"></p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'EnterpriseUse'
}
</script>
